import React, { useEffect, useRef } from "react";

let tvScriptLoadingPromise: Promise<void>;

interface TradingViewChartProps {
  symbol: string;
  height: number;
}

export const TradingViewChart = ({ symbol, height }: TradingViewChartProps) => {
  const onLoadScriptRef = useRef<(() => void) | null>(null);

  useEffect(() => {
    onLoadScriptRef.current = createWidget;

    if (!tvScriptLoadingPromise) {
      tvScriptLoadingPromise = new Promise(resolve => {
        const script = document.createElement("script");
        script.id = "tradingview-widget-loading-script";
        script.src = "https://s3.tradingview.com/tv.js";
        script.type = "text/javascript";
        script.onload = resolve as () => void;
        document.head.appendChild(script);
      });
    }

    tvScriptLoadingPromise.then(() => onLoadScriptRef.current && onLoadScriptRef.current());

    return () => {
      onLoadScriptRef.current = null;
    };

    function createWidget() {
      if (document.getElementById("tradingview_chart") && "TradingView" in window) {
        new (window as any).TradingView.widget({
          autosize: true,
          hide_side_toolbar: false,
          symbol: `BINANCE:${symbol}USDT`,
          interval: "D",
          timezone: "Etc/UTC",
          theme: "light",
          style: "1",
          locale: "en",
          enable_publishing: false,
          allow_symbol_change: true,
          container_id: "tradingview_chart",
          studies: ["RSI@tv-basicstudies", "STD;EMA", "STD;SMA"],
          studies_overrides: {
            "RSI.length": 14,
            "RSI.overbought": 70,
            "RSI.oversold": 30,
            "RSI.plot.color": "#7E57C2",
          },
        });
      }
    }
  }, [symbol]);

  return <div id="tradingview_chart" style={{ height: height }} />;
};

